// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"AccordionToggle_ProseMirror__dxQTK","accordionToggle":"AccordionToggle_accordionToggle__w6YeU"};